import type { ReactNode } from 'react';
import { AlertCircleIcon, SpinnerIcon } from '@/components/icons';
import { Button } from '@/components/ui/Button';

export const PageHeading = ({
  title,
  description,
  icon,
  action,
}: {
  title: string;
  description: string;
  icon: ReactNode;
  action?: ReactNode;
}) => (
  <header className="portal-heading">
    <span className="portal-page-icon" aria-hidden>
      {icon}
    </span>
    <div className="portal-heading__text">
      <h1>{title}</h1>
      <p>{description}</p>
    </div>
    {action}
  </header>
);

export const SectionHeading = ({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) => (
  <header className="portal-section-heading">
    <div>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </div>
    {action}
  </header>
);

export const Metric = ({
  label,
  value,
  hint,
  accent = false,
}: {
  label: string;
  value: string;
  hint: string;
  accent?: boolean;
}) => (
  <div className={`portal-metric${accent ? ' portal-metric--accent' : ''}`}>
    <dt>{label}</dt>
    <dd>
      {value}
      <span>j</span>
    </dd>
    <dd className="portal-metric__hint">{hint}</dd>
  </div>
);

export const LoadingState = ({ children }: { children: ReactNode }) => (
  <p role="status" className="portal-loading">
    <SpinnerIcon />
    {children}
  </p>
);

export const ErrorNotice = ({
  children,
  onRetry,
}: {
  children: ReactNode;
  onRetry?: () => void;
}) => (
  <div role="alert" className="portal-notice">
    <AlertCircleIcon aria-hidden />
    <div>{children}</div>
    {onRetry && (
      <Button size="sm" variant="secondary" onClick={onRetry}>
        Réessayer
      </Button>
    )}
  </div>
);
